<template>
  <div class="archive-location-sidepanel">
    <div class="title text-center d-flex justify-content-between mb-2 p-3">
      <span>H1A20-000001-A</span>
      <b-button
        v-shortkey="['shift', 'esc']"
        class="btn__icon btn__icon--primary p-0 pr-0"
        @click="closeArchiveLocationSidepanel"
        @shortkey="closeArchiveLocationSidepanel"
      >
        <i
          class="far fa-times"
          aria-hidden="true"
        />
      </b-button>
    </div>
    <div class="px-3">
      <span class="dark">{{ $t('archive.archiveLocation.selectArchiveLocation') }}</span>
      <b-row class="mt-3">
        <b-col cols="12">
          <div class="form-label">
            <label>{{ $t('archive.archiveLocation.shelving') }}</label>
          </div>
          <div class="barcode-input">
            <b-input-group
              size="sm"
              class="mb-2 mr-sm-2 mb-sm-0"
            >
              <b-input-group-prepend>
                <b-input-group-text>
                  <fa-icon :icon="['fal', 'barcode-alt']" />
                </b-input-group-text>
              </b-input-group-prepend>
              <vt-input class="form-control-sm" />
            </b-input-group>
          </div>
        </b-col>
        <b-col
          cols="12"
          class="d-none mt-2"
        >
          <div class="form-label">
            <label>{{ $t('archive.archiveLocation.cabinet') }}</label>
          </div>
          <div class="barcode-input">
            <b-input-group
              size="sm"
              class="mb-2 mr-sm-2 mb-sm-0"
            >
              <b-input-group-prepend>
                <b-input-group-text>
                  <fa-icon :icon="['fal', 'barcode-alt']" />
                </b-input-group-text>
              </b-input-group-prepend>
              <vt-input class="form-control-sm" />
            </b-input-group>
          </div>
        </b-col>
        <b-col
          cols="12"
          class="d-none mt-2"
        >
          <div class="form-label">
            <label>{{ $t('archive.archiveLocation.freezer') }}</label>
          </div>
          <div class="barcode-input">
            <b-input-group
              size="sm"
              class="mb-2 mr-sm-2 mb-sm-0"
            >
              <b-input-group-prepend>
                <b-input-group-text>
                  <fa-icon :icon="['fal', 'barcode-alt']" />
                </b-input-group-text>
              </b-input-group-prepend>
              <vt-input class="form-control-sm" />
            </b-input-group>
          </div>
        </b-col>
        <b-col
          cols="12"
          class="mt-2"
        >
          <div class="form-label">
            <label>{{ $t('archive.archiveLocation.shelf') }}</label>
          </div>
          <div class="barcode-input">
            <b-input-group
              size="sm"
              class="mb-2 mr-sm-2 mb-sm-0"
            >
              <b-input-group-prepend>
                <b-input-group-text>
                  <fa-icon :icon="['fal', 'barcode-alt']" />
                </b-input-group-text>
              </b-input-group-prepend>
              <vt-input class="form-control-sm" />
            </b-input-group>
          </div>
        </b-col>
        <b-col
          cols="12"
          class="d-none mt-2"
        >
          <div class="form-label">
            <label>{{ $t('archive.archiveLocation.drawer') }}</label>
          </div>
          <div class="barcode-input">
            <b-input-group
              size="sm"
              class="mb-2 mr-sm-2 mb-sm-0"
            >
              <b-input-group-prepend>
                <b-input-group-text>
                  <fa-icon :icon="['fal', 'barcode-alt']" />
                </b-input-group-text>
              </b-input-group-prepend>
              <vt-input class="form-control-sm" />
            </b-input-group>
          </div>
        </b-col>
        <b-col
          cols="12"
          class="d-none mt-2"
        >
          <div class="form-label">
            <label>{{ $t('archive.archiveLocation.box') }}</label>
          </div>
          <div class="barcode-input">
            <b-input-group
              size="sm"
              class="mb-2 mr-sm-2 mb-sm-0"
            >
              <b-input-group-prepend>
                <b-input-group-text>
                  <fa-icon :icon="['fal', 'barcode-alt']" />
                </b-input-group-text>
              </b-input-group-prepend>
              <vt-input class="form-control-sm" />
            </b-input-group>
          </div>
        </b-col>
        <b-col
          cols="12"
          class="d-none mt-2"
        >
          <div class="form-label">
            <label>{{ $t('archive.archiveLocation.column') }}</label>
          </div>
          <div class="barcode-input">
            <b-input-group
              size="sm"
              class="mb-2 mr-sm-2 mb-sm-0"
            >
              <b-input-group-prepend>
                <b-input-group-text>
                  <fa-icon :icon="['fal', 'barcode-alt']" />
                </b-input-group-text>
              </b-input-group-prepend>
              <vt-input class="form-control-sm" />
            </b-input-group>
          </div>
        </b-col>
        <b-col
          cols="12"
          class="d-none mt-2"
        >
          <div class="form-label">
            <label>{{ $t('archive.archiveLocation.row') }}</label>
          </div>
          <div class="barcode-input">
            <b-input-group
              size="sm"
              class="mb-2 mr-sm-2 mb-sm-0"
            >
              <b-input-group-prepend>
                <b-input-group-text>
                  <fa-icon :icon="['fal', 'barcode-alt']" />
                </b-input-group-text>
              </b-input-group-prepend>
              <vt-input class="form-control-sm" />
            </b-input-group>
          </div>
        </b-col>
        <b-col
          cols="12"
          class="d-none mt-2"
        >
          <div class="form-label">
            <label>{{ $t('archive.archiveLocation.position') }}</label>
          </div>
          <div class="barcode-input">
            <b-input-group
              size="sm"
              class="mb-2 mr-sm-2 mb-sm-0"
            >
              <b-input-group-prepend>
                <b-input-group-text>
                  <fa-icon :icon="['fal', 'barcode-alt']" />
                </b-input-group-text>
              </b-input-group-prepend>
              <vt-input class="form-control-sm" />
            </b-input-group>
          </div>
        </b-col>
        <b-col
          cols="12"
          class="mt-4 d-flex justify-content-end"
        >
          <b-button
            qa="archive-apply-archive-location"
            size="sm"
            class="btn__outline"
            @click="closeArchiveLocationSidepanel"
          >
            <i
              class="far fa-check mr-2"
              aria-hidden="true"
            />
            {{ $t('global.apply') }}
          </b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
    name: 'ArchiveLocationSidepanel',
    data() {
        return {
            selected: null,
            options: [
                { value: 'a', text: 'Opción 1' },
                { value: 'b', text: 'Opción 2' },
                { value: 'b', text: 'Opción 3' }
            ]
        }
    },
    methods: {
        closeArchiveLocationSidepanel() {
            this.$emit('closeArchiveLocationSidepanel', false)
        }
    }
}
</script>

<style lang="scss">
    .archive-location-sidepanel .barcode-input {
        border: 1px solid vt-color(grid-general-border);
        border-radius: 5px;
        height: 32px;
        padding-top: 1px;
    }
    .archive-location-sidepanel .input-group-text {
        border-radius: 14px;
        color: vt-color(search-bar-text);
        border: none;
        background-color: inherit;
        font-size: 12px;
        padding-left: 12px;
    }
    .archive-location-sidepanel input {
        width: 150px;
        border: none;
        color: vt-color(search-bar-text);
        background-color: inherit;
        font-size:1.1rem;
        padding-top:0.4rem;
    }
    .archive-location-sidepanel {
        background: #FFF;
        width: 300px;
        position: absolute;
        right: 0;
        top: 0;
        height: 100%;
        z-index: 4;
        box-shadow: -5px 0 5px -5px #b2b2b2;
        border: 1px solid vt-color(grid-general-border);
    }
    .archive-location-sidepanel .title {
        color: vt-color(primary);
    }
</style>
